<template>
  <div class="et-tab" role="tablist">
    <div
      v-for="tab in tabs"
      :key="tab.value"
      role="tab"
      :aria-selected="value == tab.value"
      class="et-tab__item"
      :class="{ active: value == tab.value }"
      @click="onClick(tab)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Number,
    default: 1,
  },
  tabs: {
    type: Array,
    default: () => [],
  }
})
const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
  }
})

function onClick(tab) {
  value.value = tab.value
}

</script>
<style scoped>
.et-tab {
  display: flex;
  gap: 2px;
  height: 32px;
  padding: 2px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.22);
  color: rgba(255, 255, 255, 0.5);
}

.et-tab__item {
  flex: 1;
  height: 28px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.et-tab__item:hover:not(.active) {
  color: rgba(255, 255, 255, 0.78);
  background: rgba(255, 255, 255, 0.06);
}

.et-tab__item.active {
  color: #fff;
  background: #2b3657;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.et-tab__item:focus-visible {
  outline: 2px solid #178ffc;
  outline-offset: 1px;
}

@media (prefers-reduced-motion: reduce) {
  .et-tab__item {
    transition: none;
  }
}
</style>
